import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import SharedPropsService, { getBuildType } from '../../../SharedPropsService';
import { ACTION } from './types';
import { GoBackAction, NavigateNext, initiateESign, contactUs, CallApi, handleAndroidCallback, closeErrorModal, startKfsGeneration, } from './actions';
import { getLenderInfo, horizontalStepperRepo, isFromJupiter } from '../../../configs/utils';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import AsyncStorage from '@react-native-async-storage/async-storage';
export const template = (pan, stepper, height, lenderInfo, isJupiter, digioDeepCheckFailure, digioDeepCheckSuccess) => ({
    layout: {
        id: ROUTE.SIGN_DESK_ESIGN,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'DigioAgreementPage', type: WIDGET.DIGIO_AGREEMENT_PAGE
            }
        ],
    },
    datastore: {
        DigioAgreementPage: {
            height: height,
            lenderInfo: lenderInfo,
            continueAction: {
                routeId: ROUTE.SIGN_DESK_ESIGN,
                type: ACTION.NAV_TO_BANK_ADD,
                payload: {}
            },
            startKfsPollingAction: {
                routeId: ROUTE.SIGN_DESK_ESIGN,
                type: ACTION.START_KFS_GENERATION,
                payload: {}
            },
            stepperProps: stepper,
            backAction: {
                routeId: ROUTE.SIGN_DESK_ESIGN,
                type: ACTION.GO_BACK,
                payload: {}
            },
            contactUsAction: {
                routeId: ROUTE.SIGN_DESK_ESIGN,
                type: ACTION.TOGGLE_CTA,
                payload: {}
            },
            callWebApiAction: {
                routeId: ROUTE.SIGN_DESK_ESIGN,
                type: ACTION.CALL_WEB_API,
                payload: {}
            },
            proceedToNextAction: {
                type: ACTION.NAVIGATION_NEXT,
                routeId: ROUTE.SIGN_DESK_ESIGN,
                payload: {}
            },
            androidCallBackAction: {
                type: ACTION.HANDLE_ANDROID_CALLBACK,
                routeId: ROUTE.SIGN_DESK_ESIGN,
                payload: {}
            },
            closeErrorModalAction: {
                type: ACTION.CLOSE_ERROR_MODAL,
                routeId: ROUTE.SIGN_DESK_ESIGN,
                payload: {}
            },
            hidePopUpAction: {
                type: ACTION.CLOSE_ERROR_MODAL,
                routeId: ROUTE.SIGN_DESK_ESIGN,
                payload: {}
            },
            buildType: getBuildType(),
            loading: false,
            isJupiter: isJupiter,
            digioDeepCheckFailure: digioDeepCheckFailure,
            digioDeepCheckSuccess: digioDeepCheckSuccess,
            showErrorCard: false,
            errorMessage: '',
        },
    },
});
export const signDeskSign = {
    onLoad: async ({ getHeight, network }, { digioDeepCheckFailure, digioDeepCheckSuccess }) => {
        const user = await SharedPropsService.getUser();
        const pan = user.linkedBorrowerAccounts[0].accountHolderPAN;
        const lenderInfo = await getLenderInfo(network);
        const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
        await network.post(`${api.initKfsTata}${applicationId}`, {}, {
            headers: await getAppHeader(),
            handleFromMF: true
        });
        const stepper = await horizontalStepperRepo(network);
        const isJupiter = await isFromJupiter();
        return Promise.resolve(template(pan, stepper, getHeight(), lenderInfo, isJupiter, digioDeepCheckFailure, digioDeepCheckSuccess));
    },
    actions: {
        [ACTION.NAV_TO_BANK_ADD]: initiateESign,
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.TOGGLE_CTA]: contactUs,
        [ACTION.NAVIGATION_NEXT]: NavigateNext,
        [ACTION.CALL_WEB_API]: CallApi,
        [ACTION.HANDLE_ANDROID_CALLBACK]: handleAndroidCallback,
        [ACTION.CLOSE_ERROR_MODAL]: closeErrorModal,
        [ACTION.START_KFS_GENERATION]: startKfsGeneration
    },
};
